import {ImImportService} from "./service/api/im-import.service";
import {ImSchemaFileService} from "./service/api/im-schema-file.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {ImImportObjectComponent} from "./component/object-components/object-component/im-import-object.component";
import {
    ImSchemaObjectComponent
} from "./component/protected-components/im-schema-object-component/im-schema-object.component";

export const IM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['im.ImImport', {route: '/im/config', service: ImImportService, objectComponent: [{component: ImImportObjectComponent}]}],
            ['im.ImSystem', {route: '/im/imSystems'}],
            ['im.ImImportRecord', {route: '/im/imImportRecords'}],

            ['im.ImExceptionHandler', {route: null}],
            ['im.ImEntityExternal', {route: '/im/imEntityExternals'}],
            ['im.ImSchemaFile', {route: '/im/imSchemaFiles', service: ImSchemaFileService, objectComponent: [{component: ImSchemaObjectComponent}]}],
            ['im.ImBatchJobErrorLog', {route: '/im/imBatchJobErrorLogs'}],
            ['im.ImSystemCertificate', {route: '/im/imSystemCertificates'}],
            ['im.ImEventBus', {route: '/im/imEventBuss'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
